function init() {

    wrapTables();

}


function wrapTables() {
    $(".main-content-sac").find("table").each(function (i, elem) {
        $(elem).wrap('<div class="table-responsive"></div>');
    });
}

export default {
    init
}